import React, { useEffect, useState } from "react";
import Text from "ab-text";
import Link from "ab-link";
import { useTranslation } from "next-i18next";
import { useEboxContext } from "ab-context-ebox";

import "./card-e-box.scss";

const CardEBox = ({
  src,
  srcSet,
  label,
  href,
  title,
  description,
  link,
  price,
  producto,
  selected,
  i18n,
}) => {
  // console.log("CardEBox", href, link);
  const { t } = useTranslation("common", { i18n });
  const [viewMore, setViewMore] = useState(false);
  const [_selected, setSelected] = useState(selected || false);
  const [stateEbox, dispatchEbox] = useEboxContext();
  const { addItemToEbox, resetEbox, removeItemFromEbox } = dispatchEbox;

  useEffect(() => {
    setSelected(selected);
  }, [selected]);
  if (producto?.sku === "EB00032" || producto?.sku === "EB00031") return null;
  return (
    <div
      className={`card-e-box${_selected ? " selected" : ""}`}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        if (producto) {
          if (_selected) {
            removeItemFromEbox(producto);
            setSelected(false);
          } else {
            addItemToEbox(producto);
            setSelected(true);
          }
        }
      }}
    >
      <a href={href || link?.url}>
        {src ? (
          <div className="image">
            <picture>
              <source srcSet={srcSet} media="(max-width: 850px)" />
              <img src={src} loading="lazy" alt={label || title} />
            </picture>
          </div>
        ) : null}

        <div className="content">
          <div className={`checkbox${_selected ? " selected" : ""} `}></div>
          <div>
            {label ? <Text element="h1">{label}</Text> : null}
            {title ? (
              <Text element="h1" className="title">
                {title}
              </Text>
            ) : null}

            {viewMore ? (
              <Text element="span" className="description">
                {description}
              </Text>
            ) : null}

            <Link
              prefetch={false}
              text={viewMore ? t("cerrar") : t("saber-mas")}
              style={{
                borderWidth: 0,
                padding: 0,
                textDecoration: "underline",
                marginTop: 10,
              }}
              onClick={(e) => {
                e.stopPropagation();
                setViewMore(!viewMore);
              }}
            ></Link>
            {price ? (
              <Text element="span" className="price">
                {`${price}`}
              </Text>
            ) : null}
          </div>
        </div>
      </a>

      {link && link?.title ? (
        <Link
          prefetch={false}
          text={link?.title || "Descubrir"}
          href={link?.href || link?.url}
          target={link.target}
          style={{ width: "fit-content" }}
        />
      ) : null}
    </div>
  );
};

export default CardEBox;
